/**
 * Вхід у чанк «Моїх задач» для першого екрана: один `import()` на список і панель «Сьогодні».
 * Звідси ж — форма задачі: статичний імпорт поклав би її в спільний `routes`.
 */
export const loadMyTasks = () => import('./MyTasksPage.tsx');
